export const firebaseConfig = {
  apiKey: 'AIzaSyAfXNPz42q8pvrT0X26WSmTPhGh4axmUSg',
  authDomain: 'messanger-b3a03.firebaseapp.com',
  projectId: 'messanger-b3a03',
  storageBucket: 'messanger-b3a03.appspot.com',
  messagingSenderId: '284623113698',
  appId: '1:284623113698:web:bc45b7ced349d9b19f3dbb',
  databaseURL: "https://messanger-b3a03-default-rtdb.europe-west1.firebasedatabase.app/",
};
